import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=0179b1d4"
import script from "./CatalogSearch.vue?vue&type=script&lang=ts"
export * from "./CatalogSearch.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=0179b1d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports